import { postPDF, downloadPDF } from '../services/SharepointService';
import type { WorkPreparationState } from './WorkPreparationState';

export const generateWorkPreparationDocuments = (workPrep: WorkPreparationState) =>
  postPDF(workPrep);

export const printWorkPreparationDocuments = (
  workPrep: WorkPreparationState & { sharePointFolderId?: string | null },
) => downloadPDF(workPrep);
